/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Statusinprogress2Inputs */

const zh_learn_statusinprogress2 = /** @type {(inputs: Learn_Statusinprogress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行中`)
};

const en_learn_statusinprogress2 = /** @type {(inputs: Learn_Statusinprogress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Progress`)
};

const es_learn_statusinprogress2 = /** @type {(inputs: Learn_Statusinprogress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En progreso`)
};

/**
* | output |
* | --- |
* | "In Progress" |
*
* @param {Learn_Statusinprogress2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_statusinprogress2 = /** @type {((inputs?: Learn_Statusinprogress2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Statusinprogress2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_statusinprogress2(inputs)
	if (locale === "en") return en_learn_statusinprogress2(inputs)
	return es_learn_statusinprogress2(inputs)
});
export { learn_statusinprogress2 as "learn_statusInProgress" }